export default "__VITE_ASSET__6cfb0e9a__"